interface Props {
  name: string;
  primary: string;
  secondary: string;
  size?: number;
}

/** Deterministic initials: first letters of the first two significant words. */
function initials(name: string): string {
  const skip = new Set(['of', 'the', 'at', 'and', '&']);
  const words = name
    .replace(/[^A-Za-z0-9 ]/g, ' ')
    .split(/\s+/)
    .filter((w) => w && !skip.has(w.toLowerCase()));
  const first = words[0]?.[0] ?? '?';
  const second = words[1]?.[0] ?? '';
  return (first + second).toUpperCase();
}

/** Is a hex color light enough that black text reads better than white? */
function isLight(hex: string): boolean {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex);
  if (!m) return false;
  const n = parseInt(m[1], 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  // Relative luminance (sRGB approximation).
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6;
}

export function SchoolAvatar({ name, primary, secondary, size = 40 }: Props) {
  const fg = isLight(primary) ? '#111' : '#fff';
  return (
    <span
      className="avatar"
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        background: primary,
        color: fg,
        border: `2px solid ${secondary}`,
        fontSize: size * 0.36,
      }}
    >
      {initials(name)}
    </span>
  );
}
